import { render, staticRenderFns } from "./ChangeBgPage.vue?vue&type=template&id=efc936cc&"
import script from "./ChangeBgPage.vue?vue&type=script&lang=js&"
export * from "./ChangeBgPage.vue?vue&type=script&lang=js&"
import style0 from "./ChangeBgPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports